import AccountSidebar from 'Storybook/local/AccountSidebar/AccountSidebar';

import styles from './Sidebar.module.scss';

const Sidebar: React.FC = () => (
	<aside className={styles.sidebar}>
		<div className={styles.sidebarContent}>
			<AccountSidebar />
		</div>
	</aside>
);

export { Sidebar };
